import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo.png'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="">
            <Link to="/" className="navbar-item is-hidden-desktop" title="Logo">
              <img src={logo} alt="Richard Watson" style={{ width: '125px', height: 'auto' }} />
            </Link>
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-center has-text-centered">
              {/* <Link className="navbar-item" to="/">
                Home
              </Link> */}
              <Link className="navbar-item" to="/about/">
                About
              </Link>
              {/* <Link className="navbar-item" to="/tutoring/">
                Tutoring
              </Link> */}
              {/* <Link className="navbar-item" to="/testimonials/">
                Testimonials
              </Link> */}
              {/* <Link className="navbar-item" to="/blog">
                Blog
              </Link> */}
              <Link className="navbar-item" to="/tutoring/">
                Tutoring
              </Link>
              <Link to="/" className="navbar-item is-hidden-touch" title="Logo">
              <img src={logo} alt="Richard Watson" style={{ width: '125px', height: 'auto' }} />
              </Link>
              <Link className="navbar-item" to="/contact/">
                Contact
              </Link>
              <Link className="navbar-item" to="/insights/">
                Insights
              </Link>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
